import React, { Component } from 'react';
import { Button } from '../../components/Button';
import styles from './LoginPage.module.scss';

class LogInPage extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      buttonInactive: false
    }
  }

  handleClick = () => {
    this.setState({ buttonInactive: true });
    
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    document.body.appendChild(form);
    form.submit();
    // post from current browser's path
  }

  render () {
    return (
      <div className={styles.container}>
        <img className={styles.logo} src='/images/otc-logo.svg' alt='logo' />
        <div className={styles.loginWrapper}>
          <Button title='Log in' inactive={this.state.buttonInactive} fullWidth onClick={this.handleClick} />
        </div>
      </div>
    );
  }
}

export default LogInPage;
